function getSwapAddress(application, currentApplicant) {
  const swapIndex = currentApplicant.index;
  const { applicants } = application;

  if (!swapIndex && swapIndex !== 0) return [];

  const resetIndex = 0;
  const applicantToSwapWith =
    applicants.find(({ index }) => {
      if (swapIndex + 1 > applicants.length - 1) return index === resetIndex;
      return index === swapIndex + 1;
    }) || {};

  return Object.values(applicantToSwapWith.apartments).filter(a => Boolean(a));
}

function getMoveTo(details, hasOneSwapAddress, i) {
  const d = details[`details${i}`];

  // Return if no details 2
  if (!d) {
    return '';
  }

  if (hasOneSwapAddress) return 'ONE';
  else if (d.moveToApartment) return d.moveToApartment;
  return d.freeTextAddress;
}

export default {
  getSwapAddress,
  getMoveTo,
};



// WEBPACK FOOTER //
// ./src/features/Application/helper.js